import { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import AuthContext from "./contexts/authContext";

export function PrivateRoute({ component: Component, history: any = null, ...rest }) {
  const { IsLogged } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={props => IsLogged() ?
        (<Component {...props} {...rest} />) :
        (<Redirect to={{ pathname: "/" }} />)
      }
    />);
};
